import * as Types from '../constants/Types';

export const getRateCodeCampaignList = (params) => ({ type: Types.RATECODE_CAMPAIGN_LIST_ACTION, params });
export const setRateCodeCampaignList = (data) => ({ type: Types.RATECODE_CAMPAIGN_LIST_SUCCESS, ...data });

export const createRateCodeCampaign = (campaign) => ({ type: Types.RATECODE_CAMPAIGN_CREATE_ACTION, campaign });

export const getRateCodeListAll = (params) => ({ type: Types.RATECODE_LIST_ALL_ACTION, params });
export const setRateCodeListAll = (data) => ({ type: Types.RATECODE_LIST_ALL_SUCCESS, ...data });

export const getRateCodeListWithPaging = (params, payload = {}) => ({ type: Types.RATECODE_LIST_WITH_PAGING_ACTION, params, ...payload });
export const setRateCodeListWithPaging = (data) => ({ type: Types.RATECODE_LIST_WITH_PAGING_SUCCESS, ...data });

export const getRateCodeList = (params) => ({ type: Types.RATECODE_LIST_ACTION, params });
export const setRateCodeList = (data) => ({ type: Types.RATECODE_LIST_SUCCESS, ...data });

export const createRateCodeDetail = (rateCode) => ({ type: Types.RATECODE_DETAIL_CREATE_ACTION, rateCode });

export const getRateCodeDetail = (id) => ({ type: Types.RATECODE_DETAIL_ACTION, id });
export const setRateCodeDetail = (rateCode) => ({ type: Types.RATECODE_DETAIL_SUCCESS, rateCode });
export const getRateCodeDetailCache = (id, payload = {}) => ({ type: Types.RATECODE_DETAIL_CACHE_ACTION, id, ...payload });
export const setRateCodeDetailCache = (rateCode) => ({ type: Types.RATECODE_DETAIL_CACHE_SUCCESS, rateCode });

export const getRateCodeSchedule = (id) => ({ type: Types.RATECODE_SCHEDULE_ACTION, id });
export const setRateCodeSchedule = (rateCodeSchedule) => ({ type: Types.RATECODE_SCHEDULE_SUCCESS, rateCodeSchedule });

export const createRateCodeSchedule = (rateCodeSchedule) => ({ type: Types.RATECODE_SCHEDULE_CREATE_ACTION, rateCodeSchedule });

export const updateRateCode = (rateCode) => ({ type: Types.RATECODE_UPDATE_ACTION, rateCode });

export const lockRateCode = (rateCode, params) => ({ type: Types.RATECODE_LOCK_ACTION, rateCode, params });

export const getRateCodeUsagePlanDetail = (rateCode, payload = {}) => ({ type: Types.RATECODE_USAGE_PLAN_DETAIL_ACTION, rateCode, ...payload });

export const getStockProducts = (params = {}) => ({ type: Types.STOCK_PRODUCTS_ACTION, params });
export const setStockProducts = (data) => ({ type: Types.STOCK_PRODUCTS_SUCCESS, data });
